import { useQuery } from '@tanstack/react-query';
import { get, api } from '../../../../lib/api';

export const useGetFollowUps = () =>
  useQuery(['followUps'], () =>
    get('/api/client_admin/send/tiles_follow_up_email'),
  );

export const deleteFollowUp = ({ followUpId }) => {
  return api({
    method: 'delete',
    url: `/api/client_admin/send/tiles_follow_up_email/${followUpId}`,
  });
};

export const editFollowUp = ({ followUp, followUpId }) => {
  return api.put(`/api/client_admin/send/tiles_follow_up_email/${followUpId}`, {
    follow_up_digest_email: {
      subject: followUp.subject,
      send_on: followUp.sendOn,
    },
  });
};

export const sendNow = ({ followUpId }) => {
  return api({
    method: 'put',
    url: `/api/client_admin/send/tiles_follow_up_email/send_now/${followUpId}`,
  });
};
